export enum Mode {
  Live = 'live',
  Maintenance = 'maintenance',
}

export interface Status {
  mode: Mode;
}
